import { render, staticRenderFns } from "./AdminMenuCom.vue?vue&type=template&id=66f9f339&"
import script from "./AdminMenuCom.vue?vue&type=script&lang=ts&"
export * from "./AdminMenuCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports